import Vue from 'vue';

export const updateBundle = (state, { bundle, counters }) => {
    Vue.set(state, bundle, counters);
};
